import React from 'react';
import mvp from '../datos/productos-mvp.json';
import { PerfilRiesgoAutos } from './PerfilRiesgoAutos';

// "Perfil del caso": respuestas del perfilamiento + elección en el comparador (o motivo de escala)
export const PerfilCaso = ({ perfil }) => {
  const ramos = Object.values(perfil || {});
  if (!ramos.length) return null;
  return (
    <div className="perfil-caso" data-testid="perfil-caso">
      {ramos.map((r) => (
        <div key={r.ramo} className="perfil-caso-ramo" data-testid={`perfil-caso-${r.ramo}`}>
          <span className="perfil-caso-k">Perfil del caso · {mvp.ramos[r.ramo].nombre}</span>
          <ul>
            {r.respuestas.map(([l, v]) => (
              <li key={l}><b>{l}:</b> {v}</li>
            ))}
            {r.eleccion ? <li data-testid={`perfil-caso-eleccion-${r.ramo}`}><b>Eligió en el comparador:</b> {r.eleccion}</li> : null}
            {(r.opciones || []).length ? (
              <li data-testid={`perfil-caso-otras-${r.ramo}`}>
                <b>{r.eleccion && r.opciones.includes(r.eleccion) ? 'Las otras que comparó:' : 'Opciones que comparó:'}</b>{' '}
                {r.opciones.filter((n) => n !== r.eleccion).join('; ')}
              </li>
            ) : null}
            {r.escalado ? <li className="aviso"><b>Pasa al asesor:</b> {r.escalado}</li> : null}
          </ul>
          {r.ramo === 'autos' && r.answers ? <PerfilRiesgoAutos answers={r.answers} /> : null}
        </div>
      ))}
    </div>
  );
};
